import Product from "../../../../../../@types/Product";
import Batteries from "../../Shared/Batteries";


const LithiumBattery105AH = Batteries[0];
const LithiumBattery60AH = Batteries[1];

const ChassisBatteryConfigs: Product[] = [
    {
        id: 1,
        name: 'ECO Lithium Battery 60AH',
        sku: '27-042-1',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/batteries/eco-lithium-60ah.png`,
        price: 900,
        retailPrice: 0.00,
        linkedProducts: [LithiumBattery60AH],
    },
    {
        id: 2,
        name: 'ECO Lithium Battery 105AH',
        sku: '27-042-2',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/batteries/eco-lithium-105ah.png`,
        price: 1500,
        retailPrice: 1000.00,
        linkedProducts: [LithiumBattery105AH],
    },
]

const ChassisBatteryConfigsPreassembly: Product[] = [
    {
        id: 1,
        name: 'ECO Lithium Battery 60AH',
        sku: '27-030',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/batteries/eco-lithium-60ah.png`,
        price: 900,
        retailPrice: 0.00,
        linkedProducts: [LithiumBattery60AH],
    },
    {
        id: 2,
        name: 'ECO Lithium Battery 105AH',
        sku: '27-031',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/batteries/eco-lithium-105ah.png`,
        price: 1500,
        retailPrice: 1000.00,
        linkedProducts: [LithiumBattery105AH],
    },
]

export { ChassisBatteryConfigs, ChassisBatteryConfigsPreassembly };